export class ABTestGroupDTO {
  id: number;
  name: string;
  description?: string;
  idealWinner: string;
  optimizingFor: string;
  createdAt: string;
  fromNewAbTesting: boolean = false;
  moreThanTwoVariants: boolean = false;
}
